import React from "react";
import {StyledBoxRow,} from "@/shared/StyledComponents";
import {Button} from "@mui/material";
import {BaseApp} from "@/shared/BaseApp";
import {SendSmsDialog} from "@/libwyze-shared/components/SendSmsDialog";
import {BaseMessageCampaignFragment} from "../BaseMessageCampaignFragment";
import {BaseSmsCampaignCustomizeOptions} from "@/vantage-shared/types";

export type Sms = {
  body: string,
}

export abstract class BaseSmsCampaignFragment<OPTIONS extends BaseSmsCampaignCustomizeOptions> extends BaseMessageCampaignFragment<Sms, OPTIONS> {

  protected renderTestButtons(): React.ReactElement {
    return <StyledBoxRow>
      <Button
        onClick={() => {
          const id = BaseApp.CONTEXT.showDialog(
            null,
            () => <SendSmsDialog
              templateId={this.campaignConfig.messaging.templateId}
              templateVariables={this.campaignConfig.messaging.templateVariables}
              onSent={() => BaseApp.CONTEXT.hideDialog(id)}/>
          );
        }}
        variant={"outlined"}>
        Send test Sms
      </Button>
    </StyledBoxRow>;
  }
}